var map = {
	"./admin/UK/shape_of_day.csv": [
		4575,
		4575
	],
	"./brother_marcus/UK/shape_of_day.csv": [
		4396,
		4396
	],
	"./brother_marcus_south_ken/UK/shape_of_day.csv": [
		8193,
		8193
	],
	"./honest_burger/UK/shape_of_day.csv": [
		9989,
		9989
	],
	"./lina/UK/shape_of_day.csv": [
		5684,
		5684
	],
	"./pizza_express/UK/shape_of_day.csv": [
		4977,
		4977
	],
	"./sushi_dog/UK/shape_of_day.csv": [
		4335,
		4335
	],
	"./tossed/UK/shape_of_day.csv": [
		396,
		396
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 3526;
module.exports = webpackAsyncContext;